<div class="overlay">
  <div class="page-loader">
    <div class="traffic-loader"></div>
    <div class="loading_text">
      <span>Generating {{ loaderText }}...</span>
      <h6>This may take some time depending on the data provided.</h6>
    </div>
  </div>
</div>